module.exports = __webpack_public_path__ + "static/pay-in-EMIs-6a49ab966329f30fea4a67ad1b219f18.png";